import { render, staticRenderFns } from "./EventModalChangeCompany.vue?vue&type=template&id=601d8212"
import script from "./EventModalChangeCompany.vue?vue&type=script&lang=js"
export * from "./EventModalChangeCompany.vue?vue&type=script&lang=js"
import style0 from "./EventModalChangeCompany.vue?vue&type=style&index=0&id=601d8212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports